/**
 * The constants in this file is used for ShowingDetailsPageNew and ComponentsV2
 */
export const INVALID_STATUSES = [
  'removed',
  'config_change',
  'historical',
  'non_agent_approval',
] as const;

// appointment statuses for inviting buyers and get redirection
export const APPT_STATUSES_TO_INVITE = [
  'new',
  'attempted',
  'time_change',
  'suggested_time_change',
  'confirm',
];

export const DENIED_STATUSES = ['cancel', 'deny'] as const;
export const TIME_CHANGE_STATUSES = ['time_change', 'suggested_time_change'];

export type AUTO_ACTIONS = 'autoconfirm' | 'cancel' | 'deny' | 'confirm';

export const BODY_MARGIN_LEFT = 16;
export const COLUMN_MARGIN_TOP = 12;
export const BORDER_RADIUS = 8;
